import tyreStack from "../images/tyre-stack-2.png"
import '../App.css';

function CTA() {
    return (
        <div className="hero justify-start bg-zinc-800 text-white font-rescue italic">
        <div className="flex flex-row bg-white items-center image-bg-alt">
          {/* <img
            src={heroImage}
            className="max-w-sm rounded-lg shadow-2xl" /> */}
          <div className="flex flex-col items-center md:items-start gap-10 p-20 font-bold w-full md:w-2/3">
            {/* <img
            src={logo}
            className="max-w-sm rounded-lg shadow-2xl mt-10" /> */}
            <h1 className="text-2xl text-center md:text-left">Drive with Confidence <br/>Get Your Perfect Tyres Today!</h1>
            <a href="tel:+44747320871" className="btn w-1/2 !text-white bg-rescueRed hover:!text-rescueRed hover:bg-white">Call Now</a>
          </div>
          <div className="hidden md:flex md:flex-col md:p-20 md:justify-center items-center md:font-bold md:w-1/3">
            <img
            src={tyreStack}
            width={150}
            className="max-w-sm" 
            alt="tyre stack"
            />
          </div>
        </div>
      </div>
  );
}

export default CTA;
